import React, { Fragment, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import Layout from '../../Layout'
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock'
import { Link } from 'react-router-dom'
import { Col, ConfigProvider, DatePicker, Row, Select, TreeSelect } from 'antd'
import { getSLUnitByPermission } from '../../api/selectOptions/selectOptionsApi'
import { convertNationwideValueToTree_V2 } from '../../api/unit/unitApi'
import { useSelector } from 'react-redux'
import { selectorInfoUser } from '../../store/slices/infoUserSlice'
import viVN from 'antd/locale/vi_VN';
import './DataQuanlity.scss'
import TableReportDataByMonth from './TableDataCustom/TableReportDataByMonth'
import TableReportDataByCity from './TableDataCustom/TableReportDataByCity'
import VehicleOwnershipChart from './ComponentChart/VehicleOwnershipChart'
import useDebounce from '../../hook/useDebounce'
import useLoading from '../../hook/useLoading'
import useToast from '../../hook/useToast'
import { buildTopDealerWithOther, dataSelectTopReport, TYPEFILTERTOP } from './ReportCustomer'
import { getDataCustomerReportCarOwnedBrandByUnit } from '../../api/reportCustomer/reportCustomerApi'

export interface IDataDefaulFilter {
    unitId?: number[];
    businessCheck?: number[]
    gender?: number[],
    job?: number[],
    province?: number[],
    carBrand?: number[],
    age?: number[],
    group?: number[]
}

const fakeData = {

    "data": {
        "SR Sala": {
            "KIA": 13,
            "MAZDA": 14,
            "BMW": 1698,
            "PEUGEOT": 0,
            "MINI": 211,
            "TẢI": 0,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 1,
            "MOTORRAD": 516,
            "KHÁC": 0
        },
        "SR Phú Mỹ Hưng": {
            "KIA": 3148,
            "MAZDA": 2316,
            "BMW": 389,
            "PEUGEOT": 589,
            "MINI": 0,
            "TẢI": 17,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 85,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Phú Nhuận": {
            "KIA": 2991,
            "MAZDA": 2867,
            "BMW": 413,
            "PEUGEOT": 99,
            "MINI": 111,
            "TẢI": 0,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 55,
            "MOTORRAD": 375,
            "KHÁC": 0
        },
        "SR Bình Dương": {
            "KIA": 6250,
            "MAZDA": 4907,
            "BMW": 376,
            "PEUGEOT": 1042,
            "MINI": 25,
            "TẢI": 1902,
            "BUS & MINI BUS": 33,
            "PEUGEOT MTC": 111,
            "MOTORRAD": 44,
            "KHÁC": 0
        },
        "SR Vũng Tàu": {
            "KIA": 3530,
            "MAZDA": 3307,
            "BMW": 1,
            "PEUGEOT": 937,
            "MINI": 0,
            "TẢI": 708,
            "BUS & MINI BUS": 124,
            "PEUGEOT MTC": 103,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR An Sương": {
            "KIA": 6,
            "MAZDA": 3,
            "BMW": 0,
            "PEUGEOT": 0,
            "MINI": 0,
            "TẢI": 8486,
            "BUS & MINI BUS": 1180,
            "PEUGEOT MTC": 0,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Võ Văn Kiệt": {
            "KIA": 3094,
            "MAZDA": 1935,
            "BMW": 0,
            "PEUGEOT": 400,
            "MINI": 0,
            "TẢI": 0,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 83,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Trường Chinh": {
            "KIA": 2769,
            "MAZDA": 2437,
            "BMW": 0,
            "PEUGEOT": 552,
            "MINI": 0,
            "TẢI": 0,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 64,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Bình Triệu": {
            "KIA": 2433,
            "MAZDA": 1950,
            "BMW": 0,
            "PEUGEOT": 28,
            "MINI": 0,
            "TẢI": 0,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 2,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Gò Vấp": {
            "KIA": 2867,
            "MAZDA": 2119,
            "BMW": 0,
            "PEUGEOT": 14,
            "MINI": 0,
            "TẢI": 10,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 7,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Bến Lức": {
            "KIA": 899,
            "MAZDA": 854,
            "BMW": 0,
            "PEUGEOT": 78,
            "MINI": 0,
            "TẢI": 897,
            "BUS & MINI BUS": 19,
            "PEUGEOT MTC": 8,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Chơn Thành": {
            "KIA": 2720,
            "MAZDA": 1887,
            "BMW": 0,
            "PEUGEOT": 324,
            "MINI": 0,
            "TẢI": 1312,
            "BUS & MINI BUS": 74,
            "PEUGEOT MTC": 27,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Tây Ninh": {
            "KIA": 1353,
            "MAZDA": 1258,
            "BMW": 0,
            "PEUGEOT": 82,
            "MINI": 0,
            "TẢI": 592,
            "BUS & MINI BUS": 11,
            "PEUGEOT MTC": 20,
            "MOTORRAD": 0,
            "KHÁC": 0
        },
        "SR Phan Đăng Lưu": {
            "KIA": 0,
            "MAZDA": 0,
            "BMW": 0,
            "PEUGEOT": 564,
            "MINI": 0,
            "TẢI": 0,
            "BUS & MINI BUS": 0,
            "PEUGEOT MTC": 89,
            "MOTORRAD": 0,
            "KHÁC": 0
        }
    },
    "brands": [
        {
            "id": 1,
            "title": "BMW",
            "color": "#3CC3DF"
        },
        {
            "id": 2,
            "title": "KIA",
            "color": "#8979FF"
        },
        {
            "id": 3,
            "title": "MAZDA",
            "color": "#FF928A"
        },
        {
            "id": 4,
            "title": "MINI",
            "color": "#7599F4"
        },
        {
            "id": 5,
            "title": "PEUGEOT",
            "color": "#FFBE70"
        },
        {
            "id": 6,
            "title": "MOTORRAD",
            "color": "#4CA9FF"
        },
        {
            "id": 7,
            "title": "PEUGEOT MTC",
            "color": "#55C5E3"
        },
        {
            "id": 8,
            "title": "BUS & MINI BUS",
            "color": "#A382E1"
        },
        {
            "id": 9,
            "title": "TẢI",
            "color": "#8CDAAA"
        },
        {
            "id": 0,
            "title": "KHÁC",
            "color": "#CCCCCC"
        }
    ]
}

// table 2


// ─── Main Component ───────────────────────────────────────────────────────────
const DataQuality = () => {
    const { unitTemp } = useSelector(selectorInfoUser)
    const pushLoading = useLoading()
    const pushToast = useToast()


    const [dataFilter, setDataFilter] = useState<IDataDefaulFilter>()

    const [sLUnitByPermission, setSLUnitByPermission] = useState<any>()
    const [brandsCarOwnedBrandByUnit, setBrandsCarOwnedBrandByUnit] = useState<any>(fakeData.brands)
    const [dataCarOwnedBrandByUnit, setDataCarOwnedBrandByUnit] = useState<any>(fakeData.data)
    const [valueTop, setValueTop] = useState<Record<TYPEFILTERTOP, number>>({
        [TYPEFILTERTOP.JOB]: 10,
        [TYPEFILTERTOP.REGION]: 10,
        [TYPEFILTERTOP.BRAND]: 10,
        [TYPEFILTERTOP.BRANDSANDDEALERSHIPS]: 10,
        [TYPEFILTERTOP.CUSTOMERJOBS]: 10,
        [TYPEFILTERTOP.VEHICLEOWNERSHIPREPORTBYBRAND]: 10,
        [TYPEFILTERTOP.CUSTOMERBYINFORMATIONCHANNEL]: 10
    });

    // const dataFormatCarOwnedBrandByUnit = useMemo(() => buildTopDealerWithOther(formatVehicleOwnershipChart(chartData), valueTop[TYPEFILTERTOP.BRANDSANDDEALERSHIPS])
    //     , [formatVehicleOwnershipChart(chartData), valueTop[TYPEFILTERTOP.BRANDSANDDEALERSHIPS]])
    const dataFormatCarOwnedBrandByUnit = useMemo(() => buildTopDealerWithOther(dataCarOwnedBrandByUnit, valueTop[TYPEFILTERTOP.BRANDSANDDEALERSHIPS])
        , [dataCarOwnedBrandByUnit, valueTop[TYPEFILTERTOP.BRANDSANDDEALERSHIPS]])

    const gSLUnitByPermission = async () => {
        const result = await getSLUnitByPermission(unitTemp);
        if (result?.status) {
            setSLUnitByPermission(convertNationwideValueToTree_V2(result.data))
        }
    }

    // Thông tin báo cáo thương hiệu được sở hữu nhiều nhất theo đơn vị bán xe
    const gDataCustomerReportCarOwnedBrandByUnit = useDebounce(async () => {
        // // setLoading("customerReportCarOwnedBrandByUnit", true)
        // const resultCarOwnedBrandByUnit = await getDataCustomerReportCarOwnedBrandByUnit(
        //     unitTemp, dataFilter
        // )
        // if (resultCarOwnedBrandByUnit?.status) {
        //     setDataCarOwnedBrandByUnit(formatVehicleOwnershipChart(resultCarOwnedBrandByUnit.data))
        //     setBrandsCarOwnedBrandByUnit(resultCarOwnedBrandByUnit.brands)
        // } else {
        //     pushToast(resultCarOwnedBrandByUnit?.message, "error")
        // }
        // setLoading("customerReportCarOwnedBrandByUnit", false)
    }, 1000)



    useEffect(() => {
        gSLUnitByPermission()
    }, [unitTemp])


    return (
        <Layout contentClassName='arc-content'>

            <BreadcrumbBlock
                items={[
                    { title: <Link to="/">THACO AUTO CRM</Link>, },
                    { title: 'Báo cáo phân tích', },
                    { title: 'Chất lượng dữ liệu', },
                ]}
                title='Chất lượng dữ liệu'
            />
            <div className="custom-page-css flex flex-col gap-3 w-full">
                <div className="custom-page-css flex items-center gap-3">
                    <Row gutter={24} className='custom-page-css w-full'>
                        <Col span={4}>
                            <TreeSelect
                                className='custom-page-css border rounded overflow-hidden w-full custom-scroll-multi-select'
                                multiple
                                showSearch
                                placeholder="Đơn vị"
                                allowClear
                                value={dataFilter?.unitId}
                                treeDefaultExpandAll={false}
                                treeData={sLUnitByPermission}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilter({ ...dataFilter, unitId: e !== undefined ? e : undefined })}
                            />
                        </Col>
                        <Col span={4}>
                            <ConfigProvider locale={viVN}>
                                <DatePicker
                                    className="w-full custom-input-date"
                                    picker="year"
                                    onChange={(e) => console.log(e)}
                                />
                            </ConfigProvider>
                        </Col>
                    </Row>

                </div>

                <TableReportDataByMonth />
                <TableReportDataByCity />


                <div
                    // ref={setRef("customerReportCarOwnedBrandByUnit")}
                    className="custom-page-css flex flex-col flex-1 border rounded-2 gap-2 p-6">
                    <div className="custom-page-css flex justify-between items-center mb-4">
                        <h3 className="custom-page-css text-344054 text-base">Biểu đồ xu hướng chất lượng dữ liệu 12 tháng</h3>
                        <Select
                            size="small"
                            bordered={false}
                            className="custom-page-css  border rounded px-1 py-2 text-344054"
                            value={valueTop[TYPEFILTERTOP.BRANDSANDDEALERSHIPS]}
                            options={dataSelectTopReport}
                            onSelect={(value: number) =>
                                setValueTop(prev => ({
                                    ...prev,
                                    [TYPEFILTERTOP.BRANDSANDDEALERSHIPS]: value,
                                }))
                            }

                        />
                    </div>
                    <VehicleOwnershipChart
                        data={dataFormatCarOwnedBrandByUnit}
                        showLoading={true}
                        brandsCarOwnedBrandByUnit={brandsCarOwnedBrandByUnit}
                    />
                </div>


            </div>
        </Layout>
    )
}

export default DataQuality